/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// import { reaction } from 'mobx';
import * as React from 'react';
// import { IVideoMetadata } from '@msdyn365-commerce/components';

import { ICittaProductVideoData } from './citta-product-video.data';
import { ICittaProductVideoProps } from './citta-product-video.props.autogenerated';

import {
    IModuleProps,
    INodeProps
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';

import { IImageData } from '@msdyn365-commerce/core';

import { IMediaGalleryData, IMediaGalleryProps } from '@msdyn365-commerce-modules/media-gallery';
// import { IPlayerResources } from '@msdyn365-commerce/components/dist/types/videoplayer/components/data/player-resources';
// import { IPlayerData } from '@msdyn365-commerce/components/dist/types/videoplayer/players/player/Player.props';
// import * as MsDyn365 from '@msdyn365-commerce/core';
// import { getValidProductImages } from './utils';

export const enum imageSource {
    pageContext = 'pageContext',
    productId = 'productId'
}
export interface IMediaGalleryState {
    animating: boolean;
    activeIndex: number;
    mediaGalleryItems: IImageData[] | undefined;
    isImageZoomed: boolean;
    modalIsOpen: boolean;
    lastUpdate?: number;
}

export interface IMediaGalleryThumbnailsViewProps {
    ThumbnailsContainerProps: INodeProps;
    SingleSlideCarouselComponentProps: INodeProps;
    items?: IMediaGalleryThumbnailItemViewProps[];
}

export interface IMediaGalleryThumbnailItemViewProps {
    ThumbnailItemContainerProps: INodeProps;
    Picture: React.ReactElement;
}

export interface IMediaGalleryViewProps extends IMediaGalleryProps<IMediaGalleryData> {
    state: IMediaGalleryState;
    MediaGallery: IModuleProps;
    CarouselProps: INodeProps;
    Thumbnails: IMediaGalleryThumbnailsViewProps;
    Modal?:React.ReactElement|null;
}


export interface ICittaProductVideoViewProps extends ICittaProductVideoProps<{}> {
    player: INodeProps;
    ProductVideoContainer: IModuleProps
}

/**
 * Media gallery component
 */
class CittaProductVideo extends React.Component<ICittaProductVideoProps<ICittaProductVideoData>, IMediaGalleryState> {
    public render(): JSX.Element | null {
        const {
            className
        } = this.props.config;

        const content: ICittaProductVideoData = this.props.data;

        const attributes = content.attributes.result;
        if (!attributes) {
            return null;
        }
        
        const srcAttribute = attributes?.find(attribute => attribute.Name === this.props.resources.attributeName);

        if (!srcAttribute || !srcAttribute.TextValue) {
            return null;
        }
        
        const viewProps = {
            ...this.props,
            ProductVideoContainer: {
                moduleProps: this.props,
                className: classnames('product-video-container', className)
            },
            player: <video 
                        width="100%" 
                        src={srcAttribute.TextValue} 
                        controls
                    >
                Sorry, your browser does not support the video tag.
            </video>
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default CittaProductVideo;